// 拦截非法爬虫ip
import xhr from '~/xhr';

export default async ({ req, error, $log, env: { baseUrl } }) => {
  if (process.server) {
    // x-real-ip 通过nginx配置添加
    const ip =
      req.headers['bigo-x-client-source-ip'] ||
      req.headers['x-real-ip'] ||
      req.connection.remoteAddress;
    try {
      const res = await xhr.get(`${baseUrl}/OInterface/checkIp`, { ip });
      if (res === 'server offline' || +res.status === 206) {
        error({ statusCode: 206 });
      }
    } catch (err) {
      // 接口报错了也放行。避免因为接口挂了真实用户无法访问页面
      $log &&
        $log.error('checkIpError', { msg: `拦截ip检查出错，放行用户ip:${ip}` });
      return true;
    }
  }
  return true;
};
